import Toggles from "../toggles/Toggles"
// HACK: This file attempts to duplicate the functionality of
// utils/env.utils.js to be used outside of eproject. 
// Should probably look into this because this looks like duplicity 

export const getURL = (path: string, subdomain: string) => {
    const baseHOST = process.env.REACT_APP_PLATFORM_HOST ?? null
    const platformHTTPS = process.env.REACT_APP_PLATFORM_HTTPS ?? null

    if (baseHOST) {
        const protocol = platformHTTPS == '1' ? 'https:' : document.location.protocol ?? 'http:'
        const host = subdomain + baseHOST
        const pathname = path
        const URL = protocol + '//' + host + '/' + pathname.replace(/^\//, '')
        return URL
    } else {
        const splittedHost = document.location.host.split('.')
        let splitDist = Math.max(splittedHost.length, 3)
        let slicedHost = splittedHost.slice(splitDist - 3)
        if (slicedHost[0] == 'www')
            slicedHost = slicedHost.slice(1)
        const host = subdomain + slicedHost.join('.')
        const URL = document.location.protocol + '//' + host + '/' + path
        return URL
    }

}

export const getWSURL = (path: string) => {
    return getURL(`/v2/ws/${path}`, 'api.').replace('http://', 'ws://').replace('https://', 'wss://')
}

export const getAssetURL = (path: string) => {
    let result = '';
    if (process.env.REACT_APP_PACKER_URL && process.env.REACT_APP_PACKER_URL !== null) {
        let url = new URL(path, process.env.REACT_APP_PACKER_URL);
        result = url.toString();
    } else {
        result = getURL(path, 'packer.');
    }
    return result;
}

export const getStaticURL = (path: string) => {
    return getURL(path, 'static.')
}

export const getDomainDataURL = (path: string) => {
    return getURL(path, 'domain.')
}

export const getS3ResourceURL = (resourceName: string) => {
    let route;
    try {
        route = process.env.REACT_APP_ROUTE_BUCKET
    } catch (error) {
    }
    if (!route) {
        route = `https://vibia-pro-content.s3.eu-west-1.amazonaws.com`
    }
    return `${route}/${resourceName}`
}

export const parseUrlString = (string) => {
    //replace accent characters
    let replaceArrayA = ['À', 'Á', 'Â', 'Ã', 'Ä', 'Å', 'Æ', 'Ç', 'È', 'É', 'Ê', 'Ë', 'Ì', 'Í', 'Î', 'Ï', 'Ð', 'Ñ', 'Ò', 'Ó', 'Ô', 'Õ', 'Ö', 'Ø', 'Ù', 'Ú', 'Û', 'Ü', 'Ý', 'ß', 'à', 'á', 'â', 'ã', 'ä', 'å', 'æ', 'ç', 'è', 'é', 'ê', 'ë', 'ì', 'í', 'î', 'ï', 'ñ', 'ò', 'ó', 'ô', 'õ', 'ö', 'ø', 'ù', 'ú', 'û', 'ü', 'ý', 'ÿ', 'Ā', 'ā', 'Ă', 'ă', 'Ą', 'ą', 'Ć', 'ć', 'Ĉ', 'ĉ', 'Ċ', 'ċ', 'Č', 'č', 'Ď', 'ď', 'Đ', 'đ', 'Ē', 'ē', 'Ĕ', 'ĕ', 'Ė', 'ė', 'Ę', 'ę', 'Ě', 'ě', 'Ĝ', 'ĝ', 'Ğ', 'ğ', 'Ġ', 'ġ', 'Ģ', 'ģ', 'Ĥ', 'ĥ', 'Ħ', 'ħ', 'Ĩ', 'ĩ', 'Ī', 'ī', 'Ĭ', 'ĭ', 'Į', 'į', 'İ', 'ı', 'Ĳ', 'ĳ', 'Ĵ', 'ĵ', 'Ķ', 'ķ', 'Ĺ', 'ĺ', 'Ļ', 'ļ', 'Ľ', 'ľ', 'Ŀ', 'ŀ', 'Ł', 'ł', 'Ń', 'ń', 'Ņ', 'ņ', 'Ň', 'ň', 'ŉ', 'Ō', 'ō', 'Ŏ', 'ŏ', 'Ő', 'ő', 'Œ', 'œ', 'Ŕ', 'ŕ', 'Ŗ', 'ŗ', 'Ř', 'ř', 'Ś', 'ś', 'Ŝ', 'ŝ', 'Ş', 'ş', 'Š', 'š', 'Ţ', 'ţ', 'Ť', 'ť', 'Ŧ', 'ŧ', 'Ũ', 'ũ', 'Ū', 'ū', 'Ŭ', 'ŭ', 'Ů', 'ů', 'Ű', 'ű', 'Ų', 'ų', 'Ŵ', 'ŵ', 'Ŷ', 'ŷ', 'Ÿ', 'Ź', 'ź', 'Ż', 'ż', 'Ž', 'ž', 'ſ', 'ƒ', 'Ơ', 'ơ', 'Ư', 'ư', 'Ǎ', 'ǎ', 'Ǐ', 'ǐ', 'Ǒ', 'ǒ', 'Ǔ', 'ǔ', 'Ǖ', 'ǖ', 'Ǘ', 'ǘ', 'Ǚ', 'ǚ', 'Ǜ', 'ǜ', 'Ǻ', 'ǻ', 'Ǽ', 'ǽ', 'Ǿ', 'ǿ']
    let replaceArrayB = ['A', 'A', 'A', 'A', 'A', 'A', 'AE', 'C', 'E', 'E', 'E', 'E', 'I', 'I', 'I', 'I', 'D', 'N', 'O', 'O', 'O', 'O', 'O', 'O', 'U', 'U', 'U', 'U', 'Y', 's', 'a', 'a', 'a', 'a', 'a', 'a', 'ae', 'c', 'e', 'e', 'e', 'e', 'i', 'i', 'i', 'i', 'n', 'o', 'o', 'o', 'o', 'o', 'o', 'u', 'u', 'u', 'u', 'y', 'y', 'A', 'a', 'A', 'a', 'A', 'a', 'C', 'c', 'C', 'c', 'C', 'c', 'C', 'c', 'D', 'd', 'D', 'd', 'E', 'e', 'E', 'e', 'E', 'e', 'E', 'e', 'E', 'e', 'G', 'g', 'G', 'g', 'G', 'g', 'G', 'g', 'H', 'h', 'H', 'h', 'I', 'i', 'I', 'i', 'I', 'i', 'I', 'i', 'I', 'i', 'IJ', 'ij', 'J', 'j', 'K', 'k', 'L', 'l', 'L', 'l', 'L', 'l', 'L', 'l', 'l', 'l', 'N', 'n', 'N', 'n', 'N', 'n', 'n', 'O', 'o', 'O', 'o', 'O', 'o', 'OE', 'oe', 'R', 'r', 'R', 'r', 'R', 'r', 'S', 's', 'S', 's', 'S', 's', 'S', 's', 'T', 't', 'T', 't', 'T', 't', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'W', 'w', 'Y', 'y', 'Y', 'Z', 'z', 'Z', 'z', 'Z', 'z', 's', 'f', 'O', 'o', 'U', 'u', 'A', 'a', 'I', 'i', 'O', 'o', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'A', 'a', 'AE', 'ae', 'O', 'o']

    //replace common characters
    replaceArrayA = [...replaceArrayA, '&', '£', '$', 'º', '°']
    replaceArrayB = [...replaceArrayB, '', '', '', 'o', 'o']

    //replace spaciating characters
    replaceArrayA = [...replaceArrayA, ' ', '&', '\r\n', '\n', '+', ',', '//', '.']
    replaceArrayB = [...replaceArrayB, '-', '-', '-', '-', '-', '-', '-', '-']

    const letters = string.toLowerCase().trim().split('')
    const newLetters = []
    for (const letter of letters) {
        const index = replaceArrayA.findIndex(l => l == letter)
        if (index != -1) {
            newLetters.push(replaceArrayB[index])
        } else {
            newLetters.push(letter)
        }
    }

    // replace other characters
    return newLetters.join('')
        .replace(/[^a-z0-9\-<>]/g, '')
        .replace(/[\-]+/g, '-')
        .replace(/<[^>]*>/g, '')

}

export const getServiceURLserverSide = (serviceName: string) => {

    const PLATFORM_HOST = process.env.REACT_APP_PLATFORM_HOST
    const PROTOCOL = process.env.REACT_APP_PLATFORM_HTTPS == "1" ? 'https://' : 'http://'

    switch (serviceName) {
        case ("cms"):
        case ("crm"):
        case ("documents"):
        case ("emails"):
        case ("erp"):
        case ("esat-wizard"):
        case ("images"):
        case ("masters"):
        case ("orders"):
        case ("prices"):
        case ("products"):
        case ("projects"):
        case ("support"):
        case ("users"):
            return PLATFORM_HOST ?
                `${PROTOCOL}api.${PLATFORM_HOST}/${serviceName}`
                : `http://sr-${serviceName}`
        case ("V2"):
        case ("v2"):
            return PLATFORM_HOST ?
                `${PROTOCOL}api.${PLATFORM_HOST}/v2`
                : `http://low-code:1880`
        case ("V3"):
        case ("v3"):
            return PLATFORM_HOST ?
                `${PROTOCOL}api.${PLATFORM_HOST}/v3`
                : `http://web-api`
        case ("ApiHub"):
            let subDomain = process.env.REACT_APP_FORCE_DEV_APIHUB_URL ? 'vibia.dev' : PLATFORM_HOST
            return `${PROTOCOL}apihub.${subDomain}`
        case ("domainData"):
            if (!PLATFORM_HOST) {
                throw "Cannot get static resources URL without REACT_APP_PLATFORM_HOST environment variable"
            }

            return `${PROTOCOL}domain.${PLATFORM_HOST}` // this might be should be a dynamic.env instead of being hardcoded as apihub
        case ("static"):
            if (!PLATFORM_HOST) {
                throw "Cannot get static resources URL without REACT_APP_PLATFORM_HOST environment variable"
            }
            const URL = `${PROTOCOL}static.${PLATFORM_HOST}`
            return URL
        case ("transform"):
            return process.env.TRANSFORM_HOST
        case ("sync"):
            if (!PLATFORM_HOST) {
                throw "Cannot get sync URL without REACT_APP_PLATFORM_HOST environment variable"
            }

            if (process.env.SYNC_URL) {
                return `${process.env.SYNC_URL}/api`
            }

            return `${PROTOCOL}sync.${PLATFORM_HOST}/api`
        case("legacyZend"):
            return `${PROTOCOL}${PLATFORM_HOST}/workspace/en/api`
        default:
            throw ("This service name hasn't been found, oopsie")
    }
}

export default {
    getURL,
    getAssetURL,
    getStaticURL,
    getS3ResourceURL,
    getServiceURLserverSide,
    parseUrlString
}